import { http } from '../../config/axios'

export default function putUser(user: any): Promise<string> {
  return http
    .put('api/user', user)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post user', error)
      throw Error(error.response.data)
    })
}
